<template>
  <el-upload
    ref="uploadRef"
    :accept="fileType"
    :file-list="fileList"
    :on-exceed="handleExceed"
    :limit="20"
    class="upload-demo"
    :show-file-list="false"
    action=""
    drag
    multiple
    :before-upload="handleBefore"
    :http-request="handleUpload"
  >
    <div class="upload-box">
      <div>
        <el-button type="primary" size="small">选择资源</el-button>
        <p>点击上传或将资源拖拽此页面，单次最多可选20个</p>
        <p class="tips">
          请确认您上传的资源为本企业所有，禁止上传他人作品，如有侵权行为，您将承担相应的法律责任。
        </p>
        <p class="tips">
          丝路版权网有义务采取警告、举报、封号乃至追究法律责任等一切措施。
        </p>
        <p class="desc" v-if="resourceType == 3">
          支持MP4、AVI、WMV；视频大小不能超过5G，时长需大于10秒，小于30分钟
        </p>
        <p class="desc" v-if="resourceType == 1">
          支持JPG、PNG、JPEG，图片大小不能超过20MB,分辨率需大于等于800PX
        </p>
        <p class="desc" v-if="resourceType == 2">
          支持MP3、WAV；音频大小不能超过1G，时长需大于3秒，小于20分钟
        </p>
      </div>
    </div>
  </el-upload>
</template>

<script>
import axios from "axios";
import { uploadByPieces } from "@/utils/uploadByPieces";
import { requestUrl } from "@/config/config";

export default {
  name: "uploadComponent",
  props: {
    // 接收父组件传递的参数
    resourceType: {
      type: String,
      default: "1",
    },
    fileLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      action: requestUrl + "/copyright/registration/uploadWorks",
      loadingList: false,
      fileList: [],
      totalFiles: 0, // 当此选择的所有文件
      finishedCount: 0, // 当前执行次数
      successCount: 0,
      errorCount: 0,
      originList: [],
      chooseCount: 0,
      isBigFile: false,
      bigSize: 1024 * 1024 * 20,
      progress: -1,
      message: "",
    };
  },
  computed: {
    fileType() {
      const checkType = {
        1: [".jpg", ".jpeg", ".png"],
        2: [".mp3", ".wav"],
        3: [".mp4", ".avi", ".wmv"],
      };
      console.log(checkType[this.resourceType]);
      return checkType[this.resourceType].join(",");
    },
  },
  mounted() {},
  methods: {
    // 校验规则
    getRules() {
      const checkType = {
        1: ["jpg", "jpeg", "png"],
        2: ["mp3", "wav"],
        3: ["mp4", "avi", "wmv"],
      };
      const checkSize = {
        1: 1024 * 1024 * 20,
        2: 1024 * 1024 * 1024 * 1,
        3: 1024 * 1024 * 1024 * 5,
      };
      return {
        type: checkType[this.resourceType],
        size: checkSize[this.resourceType],
      };
    },
    checkDuration(file) {
      const that = this;
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const audio = new Audio();
        audio.src = url;

        audio.onloadedmetadata = function () {
          console.log(`时长秒数`, audio.duration);
          URL.revokeObjectURL(url);
          if (audio.duration < 3 || audio.duration > 1200) {
            reject("音频时长需大于3秒，小于20分钟");
          } else {
            file.duration = audio.duration;
            resolve(true);
          }
        };

        audio.onerror = function () {
          reject("文件加载失败");
          URL.revokeObjectURL(url);
        };
      });
    },
    checkVideoDuration(file) {
      const that = this;
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.preload = "metadata";
        video.src = url;
        video.onloadedmetadata = function () {
          console.log(`时长秒数`, video.duration);
          URL.revokeObjectURL(url);
          if (video.duration < 10 || video.duration > 1800) {
            reject("视频时长需大于10秒，小于30分钟");
          } else {
            file.duration = video.duration;
            file.width = video.videoWidth;
            file.height = video.videoHeight;
            // 获取视频大小呢
            resolve(true);
          }
        };

        video.onerror = function (error) {
          console.log(`error---`, error);
          reject("文件加载失败");
          URL.revokeObjectURL(url);
        };
      });
    },
    checkImgSize(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.src = url;
        img.onload = function () {
          // 图片加载完成后，可以获取宽高
          const width = img.width;
          const height = img.height;
          URL.revokeObjectURL(url); // 释放URL
          if (width < 800) {
            reject("图片分辨率需大于等于800PX");
          } else {
            file.width = img.width;
            file.height = img.height;
            resolve(true);
          }
        };

        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject("图片加载失败");
        };
      });
    },
    handleBefore(file) {
      // 上传前检测是否有同名，同名则不上传
      let list = this.fileList;

      if (Array.isArray(list)) {
        let exist = list.find((item) => item.workFileName == file.name);
        if (exist) {
          setTimeout(() => {
            this.$message.error(`已存在同名文件${file.name}，此文件上传失败`);
          }, 300);
          return false;
        }
      }

      const { type, size } = this.getRules();
      console.log(type, size);
      const fileName = file.name;
      const fileType = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      if (!type.includes(fileType)) {
        this.$message.error("文件类型不支持");
        return false;
      }
      if (file.size > size) {
        this.$message.error("文件大小超过限制");
        return false;
      }
      if (this.resourceType == 1) {
        // 图片校验尺寸
        return this.checkImgSize(file)
          .then((result) => {
            return true;
          })
          .catch((error) => {
            this.$message.error(error);
            return Promise.reject();
          });
      }
      if (this.resourceType == 2) {
        //  音视频校验时长
        return this.checkDuration(file)
          .then((result) => {
            console.log(result);
            return true;
          })
          .catch((error) => {
            console.warn(error);
            this.$message.error(error);
            return Promise.reject();
          });
      }
      if (this.resourceType == 3) {
        // mp4 设置时长
        if (["video/mp4"].includes(file.type)) {
          return this.checkVideoDuration(file)
            .then((result) => {
              return true;
            })
            .catch((error) => {
              this.$message.error(error);
              return Promise.reject();
            });
        } else {
          // 其他格式直接跳过设置
          return true;
        }
      }
      return true; // 返回true表示文件上传成功
    },
    clearFiles() {
      console.log("清除文件");
      this.fileList = [];
      this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
    },
    getUploadRefDom() {
      return this.$refs.uploadRef;
    },
    resetCount() {
      this.successCount = 0;
      this.errorCount = 0;
      this.totalFiles = 0;
      this.finishedCount = 0;
    },
    handleExceed() {
      this.$message.error("最多只能上传20个文件");
      return;
    },
    handleError(file, fileList) {
      this.removeFailedFile(file.file);
      // 从列表中移除失败项
      if (!fileList) return;
      this.originList = fileList.filter((item) => item.uid !== file.uid);
      // 释放内存 (防止内存泄漏)
      if (file.url && file.url.startsWith("blob:")) {
        URL.revokeObjectURL(file.url);
      }
    },
    async handleSmallFile(file) {
      this.totalFiles++;
      this.$emit("loading", true);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", 2);
      try {
        const response = await axios.post(this.action, formData, {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        });

        if (response.data.code === 200) {
          // 这里可以处理上传成功后的逻辑，如保存返回的文件信息
          console.log("上传成功", response.data.data);
          this.$message.success(`上传成功`);
          this.loadingList = false; // 隐藏上传loading
          const urls = this.fileList.map((item) => item.url);
          if (!urls.includes(response.data.data.url)) {
            this.fileList.push(response.data.data);
          }
          this.successCount++;
        } else {
          this.$message.error(response.data.msg || "上传失败");
          this.loadingList = false; // 隐藏上传loading
          this.errorCount++;
          this.handleError(file);
        }
      } catch (error) {
        // this.$message.error(error)
        console.error("上传失败:", error);
        this.loadingList = false; // 隐藏上传loading
        this.errorCount++;
        this.handleError(file);
      } finally {
        this.finishedCount++;
        console.log(`this.finishedCount`, this.finishedCount);
        console.log(`this.totalFiles`, this.totalFiles);
        console.log(
          `this.finishedCount === this.totalFiles`,
          this.finishedCount === this.totalFiles
        );
        if (this.finishedCount === this.totalFiles) {
          this.$emit("fileList", this.fileList);
          this.$emit("loading", false);
        }
      }
    },
    handleBigFile(file) {
      this.$emit("loading", true);
      uploadByPieces({
        file,
        pieceSize: 20,
        concurrent: 3,
        process: (p) => {
          this.progress = p;
        },
        success: (res) => {
          this.checkFinish(res);
        },
        error: (err) => {
          this.handleChunkError(err);
        },
        type: this.resourceType,
        mode: true,
        timeLimit:
          this.resourceType == 3
            ? {
                minDuration: 3,
                maxDuration: 1200,
              }
            : null,
      });
    },
    // 移除失败的文件，释放limit名额
    removeFailedFile(targetFile) {
      // 通过ref获取上传组件实例
      const uploadInstance = this.$refs.uploadRef;
      if (!uploadInstance) return;
      // 获取当前上传的文件列表（内部维护的数组）
      const fileList = uploadInstance.uploadFiles;

      // 找到当前失败的文件在列表中的索引并移除
      const index = fileList.findIndex((file) => file.uid === targetFile.uid);
      if (index !== -1) {
        fileList.splice(index, 1); // 从列表中删除该文件
      }
    },
    // 上传方法
    handleUpload(file) {
      const size = file.file.size;
      size > this.bigSize
        ? this.handleBigFile(file.file)
        : this.handleSmallFile(file);
    },
    checkFinish(res) {
      if (res.data && res.data.skipUpload) {
        const {
          url,
          thumbnailUrl,
          frameImg,
          workFileName,
          workFileSize,
          duration,
        } = res.data;
        this.$message.success("上传成功");
        this.fileList.push({
          url,
          checked: true,
          uid: Math.random().toString(16).slice(2),
          workFileName: workFileName,
          workFileSize: workFileSize,
          thumbnailUrl: thumbnailUrl,
          frameImg: frameImg,
          duration: duration,
        });
        this.$emit("loading", false);
        this.$emit("fileList", this.fileList);
      }
    },
    handleChunkError(err) {
      this.$message.error(err.message || err);
      this.$emit("loading", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/* // 添加px转rem函数 */
@function px2rem($px) {
  /* @return ($px / 99.22) + rem; */
  @return $px;
}
.upload-demo {
  position: relative;
}

.upload-demo ::v-deep .el-upload {
  width: 100%;
  height: 263px;
}

.upload-demo ::v-deep .el-upload-dragger {
  border: 1px solid #ccc;
  border-radius: 0;
  width: 100%;
  height: 100%;
}

.upload-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: px2rem(20);
  text-align: center;
  min-height: px2rem(263);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 20px;
    font-weight: 400;
    font-size: px2rem(14);
    color: #4e89ff;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
  }

  .tips {
    color: #ff0000;
    font-weight: 600;
    font-size: px2rem(14);
    margin-top: 0px;
  }

  .desc {
    font-size: px2rem(12);
    color: #999999;
    margin-top: 0px;
  }
}

.upload-instructions {
  margin-top: px2rem(20);
  text-align: left;
}
</style>
